import type {
  ConfigurationItem,
  ParameterConfigurationItem,
} from '../../types/common'
import type { ChangeOperation } from '../workspace/types'

export const OperationClassForParameterConfigurationItem: Record<
  ParameterConfigurationItem,
  ChangeOperation['_type']
> = {
  parameterDefinition: 'ParameterDefinitionCreateOperation',
  parameterValue: 'ParameterValueCreateOperation',
  parameterValueAmendment: 'ParameterValueAmendOperation',
}

export const isParameterValueItem = (item: ConfigurationItem) =>
  item === 'parameterValue' || item === 'parameterValueAmendment'
